// import { useEffect, useMemo, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation, useParams } from "react-router-dom";
// import {
//   clearProfileState,
//   getVerifiedDocDataReducer,
// } from "../../../Redux/Reducers/VerifiedDocReducer";
// import Flag from "../../../Assets/img/Kyc/Flag1.jpg";
// import Lion from "../../../Assets/img/Kyc/Lion.png";
// import digi from "../../../Assets/img/Kyc/digi2.jpg";
// import income_tax from "../../../Assets/img/Kyc/income_tax.png";
// import adhaarMask from "../../../Assets/img/Kyc/adhaarMask.png";
// import panMask from "../../../Assets/img/Kyc/PanCardMask.png";

// const PublicDocview = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const params = useParams();
//   const QRData = useSelector((state) => state?.verified?.getVerifiedData?.data);
//   const [isCardVisible, setIsCardVisible] = useState(false);
//   const [isPanCardVisible, setIsPanCardVisible] = useState(false);
//   const [isCaptureBlocked, setIsCaptureBlocked] = useState(false);


//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       const key = event.key.toLowerCase();

//       if (key === "printscreen") {
//         event.preventDefault();
//         setIsCaptureBlocked(true);
//         return;
//       }

//       if ((event.ctrlKey || event.metaKey) && key === "p") {
//         event.preventDefault();
//         setIsCaptureBlocked(true);
//         return;
//       }

//       if ((event.ctrlKey || event.metaKey) && event.shiftKey && key === "s") {
//         event.preventDefault();
//         setIsCaptureBlocked(true);
//         return;
//       }
//     };

//     const handleBlur = () => {
//       setIsCaptureBlocked(true);
//     };

//     const handleFocus = () => {
//       setIsCaptureBlocked(false);
//     };

//     const handleVisibilityChange = () => {
//       if (document.hidden) {
//         setIsCaptureBlocked(true);
//       } else {
//         setIsCaptureBlocked(false);
//       }
//     };

//     const blockContextMenu = (event) => {
//       event.preventDefault();
//     };

//     const blockCopyPaste = (event) => {
//       event.preventDefault();
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     window.addEventListener("blur", handleBlur);
//     window.addEventListener("focus", handleFocus);
//     document.addEventListener("visibilitychange", handleVisibilityChange);
//     document.addEventListener("contextmenu", blockContextMenu);
//     document.addEventListener("copy", blockCopyPaste);
//     document.addEventListener("paste", blockCopyPaste);

//     return () => {
//       window.removeEventListener("keydown", handleKeyDown);
//       window.removeEventListener("blur", handleBlur);
//       window.removeEventListener("focus", handleFocus);
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//       document.removeEventListener("contextmenu", blockContextMenu);
//       document.removeEventListener("copy", blockCopyPaste);
//       document.removeEventListener("paste", blockCopyPaste);
//     };
//   }, []);

//   const useMediaQuery = (query) => {
//     const [matches, setMatches] = useState(false);

//     useEffect(() => {
//       const media = window.matchMedia(query);
//       if (media.matches !== matches) {
//         setMatches(media.matches);
//       }
//       const listener = () => setMatches(media.matches);
//       media.addEventListener('change', listener);
//       return () => media.removeEventListener('change', listener);
//     }, [matches, query]);

//     return matches;
//   };

//   // Move useMediaQuery to component top level
//   const isMobile = useMediaQuery('(max-width: 768px)');
//   const isSmallScreen = useMediaQuery('(max-width: 480px)');

//   const searchParams = useMemo(
//     () => new URLSearchParams(location.search),
//     [location.search]
//   );

//   const docType = (
//     params.docType || searchParams.get("docType") || "aadhar"
//   ).toLowerCase();

//   const token = decodeURIComponent(
//     params.token || searchParams.get("token") || ""
//   ).trim();

//   const { getVerifiedData, loading, error } = useSelector(
//     (state) => state?.verified || {}
//   );

//   useEffect(() => {
//     dispatch(clearProfileState());

//     if (token) {
//       dispatch(getVerifiedDocDataReducer({ token, docType }));
//     }
//   }, [dispatch, token, docType]);

//   const handleImageClick = () => {
//     setIsCardVisible((prev) => !prev);
//   };

//   const handlePanImageClick = () => {
//     setIsPanCardVisible((prev) => !prev);
//   };

//   // Get verified details based on docType
//   const verifiedDetails = QRData?.verifiedDetails || {};
//   const isVerified = QRData?.isVerified || false;

//   // Render Aadhaar Card UI
//   const renderAadhaarCard = () => {
//     const aadharData = verifiedDetails;
//     const photoBase64 = aadharData?.photo?.startsWith('/9j/')
//       ? `data:image/jpeg;base64,${aadharData.photo}`
//       : aadharData?.photo || null;
//     // const isMobile = useMediaQuery('(max-width: 768px)');
//     // const isSmallScreen = useMediaQuery('(max-width: 480px)');

//     return (
//       <div
//         style={{
//           width: "400px",
//           height: isMobile ? "590px" : "590px",
//           margin: "auto",
//           perspective: "1000px",
//           cursor: "pointer",
//         }}
//         onClick={handleImageClick}
//       >
//         <div
//           style={{
//             width: "100%",
//             height: "100%",
//             position: "relative",
//             transformStyle: "preserve-3d",
//             transition: "transform 0.6s",
//             transform: isCardVisible ? "rotateY(180deg)" : "rotateY(0deg)",
//           }}
//         >
//           {/* Front Side (Image) */}
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               backfaceVisibility: "hidden",
//               position: "absolute",
//               top: 0,
//               left: 0,
//             }}
//           >
//             <img
//               src={adhaarMask}
//               alt="Aadhaar Mask"
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 border: "2px solid gray",
//                 borderRadius: "15px",
//               }}
//             />
//           </div>

//           {/* Back Side (Card Details) */}
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               backfaceVisibility: "hidden",
//               position: "absolute",
//               top: 0,
//               left: 0,
//               transform: "rotateY(180deg)",
//               backgroundColor: "white",
//               border: "2px solid gray",
//               borderRadius: "15px",
//               padding: "10px",
//               boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-evenly",
//                 flexWrap: "wrap",
//                 rowGap: "10px",
//               }}
//             >
//               <img
//                 style={{ width: "15%", minWidth: "50px", objectFit: "contain" }}
//                 src={Lion}
//                 alt="Lion Logo"
//               />
//               <img
//                 style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
//                 src={Flag}
//                 alt="Flag Logo"
//               />
//               <img
//                 style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
//                 src="https://www.pngkey.com/png/full/224-2240746_aadhaar-logo-aadhar-card-logo-png.png"
//                 alt="Aadhaar Logo"
//               />
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 padding: "10px",
//                 flexDirection: "row",
//                 gap: "10px",
//                 alignItems: "center",
//                 flexWrap: "wrap",
//                 width: "100%",
//               }}
//             >
//               <img
//                 style={{
//                   width: "30%",
//                   minWidth: "120px",
//                 }}
//                 src={photoBase64 || "https://icon-library.com/images/man-png-icon/man-png-icon-14.jpg"}
//                 alt="Profile"
//               />
//               <div
//                 style={{
//                   textAlign: "left",
//                   flex: "1",
//                   display: "flex",
//                   flexDirection: "column",
//                   minWidth: "200px",
//                   padding: "10px",
//                 }}
//               >
//                 <h6>Name: {aadharData?.name || "N/A"}</h6>
//                 <h6>Aadhaar: {aadharData?.masked_id || "N/A"}</h6>
//                 <h6>DOB: {aadharData?.dob || "N/A"}</h6>
//                 <h6>Gender: {aadharData?.gender || "N/A"}</h6>
//               </div>
//             </div>
//             <hr />
//             <div style={{ textAlign: "left", padding: "10px" }}>
//               <h6>
//                 Address: {aadharData?.house || ""} {aadharData?.street || ""}{" "}
//                 {aadharData?.locality || ""} {aadharData?.city || ""}{" "}
//                 {aadharData?.state || ""}
//               </h6>
//             </div>
//             <hr />
//             <div
//               style={{
//                 textAlign: "left",
//                 padding: "20px",
//                 display: "flex",
//                 justifyContent: "space-evenly",
//                 flexWrap: "wrap",
//                 rowGap: "15px",
//               }}
//             >
//               <img
//                 style={{
//                   width: "55%",
//                   minWidth: "100px",
//                   height: "auto",
//                   objectFit: "contain",

//                 }}
//                 src={digi}
//                 alt="Digi Info"
//               />
//             </div>
//             <hr style={{ color: "red", width: "80%", margin: "auto", padding: "5px" }} />
//             <div style={{ display: "flex", justifyContent: "center" }}>
//               <h6>
//                 <span style={{ color: "red" }}>आधार</span> - आम आदमी का अधिकार
//               </h6>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Render PAN Card UI - now using the top-level responsive values
//   const renderPanCard = () => {
//     const panData = verifiedDetails;

//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "flex-start",
//           gap: "10px",
//           flexWrap: "wrap",
//           margin: "20px auto",
//           maxWidth: isMobile ? "95%" : "90%",
//           width: isMobile ? "100%" : "600px",
//           perspective: "1000px",
//           minHeight: isSmallScreen ? "50vh" : "65vh",
//         }}
//       >
//         <div
//           style={{
//             flex: "1 1 auto",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             transformStyle: "preserve-3d",
//             transition: "transform 0.6s",
//             transform: isPanCardVisible ? "rotateY(180deg)" : "rotateY(0deg)",
//             cursor: "pointer",
//             position: "relative",
//             maxWidth: isMobile ? "100%" : "60%",
//             padding: isMobile ? "5px" : "10px",
//           }}
//           onClick={handlePanImageClick}
//         >
//           {/* Front Side - Pan Mask */}
//           <div
//             style={{
//               position: "absolute",
//               backfaceVisibility: "hidden",
//               width: "100%",
//               marginTop: isSmallScreen ? "40vh" : "60vh",
//               paddingTop: isSmallScreen ? "20vh" : ""

//             }}
//           >
//             <img
//               src={panMask}
//               alt="Pan Mask"
//               style={{
//                 border: "2px solid gray",
//                 borderRadius: "15px",
//                 width: isMobile ? "100%" : "90%",
//                 height: isSmallScreen ? "55vh" : "65vh",

//               }}
//             />
//           </div>

//           {/* Back Side - PAN Card */}
//           <div
//             style={{
//               position: "absolute",
//               backfaceVisibility: "hidden",
//               transform: "rotateY(180deg)",
//               width: "100%",
//               marginTop: "65vh",
//             }}
//           >
//             <div
//               style={{
//                 border: "2px solid gray",
//                 borderRadius: "15px",
//                 padding: "20px",
//                 boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
//                 backgroundColor: "white",
//               }}
//             >
//               {/* Header */}
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-evenly",
//                   flexWrap: "wrap",
//                   rowGap: "10px",
//                 }}
//               >
//                 <img
//                   style={{ width: "15%", minWidth: "50px", objectFit: "contain" }}
//                   src={Lion}
//                   alt="Lion Logo"
//                 />
//                 <img
//                   style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
//                   src={Flag}
//                   alt="Flag Logo"
//                 />
//                 <img
//                   style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
//                   src={income_tax}
//                   alt="Income Tax Logo"
//                 />
//               </div>
//               <hr style={{ color: "blue" }} />

//               {/* Details Section */}
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "row",
//                   gap: "20px",
//                   alignItems: "center",
//                   flexWrap: "wrap",
//                   marginTop: "15px",
//                   justifyContent: "center",
//                 }}
//               >
//                 <div style={{ textAlign: "left", flex: "1 1 auto", alignItems: "flex-start" }}>
//                   <p style={{ margin: "5px 0" }}>
//                     <strong style={{ fontSize: "16px" }}>PAN Card</strong>
//                   </p>
//                   <p style={{ margin: "5px 0" }}>
//                     Name: {panData?.name || "N/A"}
//                   </p>
//                   <p style={{ margin: "5px 0" }}>
//                     PAN Number:
//                     <span style={{ marginLeft: "5px" }}>
//                       {panData?.pan_number || "N/A"}
//                     </span>
//                   </p>
//                   <p style={{ margin: "5px 0" }}>
//                     DOB: {panData?.dob || "N/A"}
//                   </p>
//                   <p style={{ margin: "5px 0" }}>
//                     Gender: {panData?.gender || "N/A"}
//                   </p>
//                 </div>
//               </div>
//               <hr />
//               <p style={{ textAlign: "center", margin: "5px 0" }}>
//                 Digilocker | NEOIN
//               </p>
//               <hr />

//               {/* Additional Details */}
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   flexWrap: "wrap",
//                   gap: "5px",
//                   marginTop: "10px",
//                   marginBottom: "10px",
//                   padding: "5px",
//                 }}
//               >
//                 <img
//                   style={{
//                     width: "80%",
//                     height: "auto",
//                     objectFit: "contain",
//                   }}
//                   src={digi}
//                   alt="Digilocker Logo"
//                 />
//               </div>
//               <hr style={{ color: "blue", padding: "5px" }} />

//               <div style={{ textAlign: "center" }}>
//                 <h6>स्थायी खाता संख्या कार्ड</h6>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Render Document Card based on docType
//   const renderDocumentCard = () => {
//     if (docType === "aadhar") {
//       return renderAadhaarCard();
//     } else if (docType === "pan") {
//       return renderPanCard();
//     }
//     return (
//       <div style={{ textAlign: "center", padding: "40px" }}>
//         <h3>Unsupported document type: {docType}</h3>
//       </div>
//     );
//   };



//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         padding: "32px 16px",
//         background:
//           "linear-gradient(180deg, #f8fafc 0%, #eef2ff 45%, #ffffff 100%)",
//         position: "relative",
//         userSelect: "none",
//         WebkitUserSelect: "none",
//       }}
//     >
//       {isCaptureBlocked && (
//       <div
//         style={{
//           position: "absolute",
//           inset: 0,
//           zIndex: 20,
//           background: "rgba(15, 23, 42, 0.82)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           textAlign: "center",
//           color: "#ffffff",
//           padding: "24px",
//           backdropFilter: "blur(6px)",
//         }}
//       >
//         <div>
//           <h2 style={{ margin: 0, fontSize: "24px" }}>
//             Screen capture is disabled on this page
//           </h2>
//           <p style={{ marginTop: "12px", fontSize: "16px" }}>
//             Switch back to the tab to continue viewing the document.
//           </p>
//         </div>
//       </div>
//     )}
//       <div
//         style={{
//           maxWidth: "960px",
//           height: isMobile ? "950px" : "",
//           margin: "0 auto",
//           background: "rgba(255,255,255,0.9)",
//           border: "1px solid #e5e7eb",
//           borderRadius: "24px",
//           boxShadow: "0 18px 60px rgba(15, 23, 42, 0.08)",
//           overflow: "hidden",

//         }}
//       >
//         <div style={{ padding: "28px" }}>
//           <div
//             style={{
//               display: "flex",
//               gap: "12px",
//               flexWrap: "wrap",
//               marginBottom: "20px",
//             }}
//           >
//             <span
//               style={{
//                 padding: "8px 12px",
//                 borderRadius: "999px",
//                 background: "#eff6ff",
//                 color: "#1d4ed8",
//                 fontSize: "13px",
//                 fontWeight: 600,
//               }}
//             >
//               Document: {docType}
//             </span>
//             <span
//               style={{
//                 padding: "8px 12px",
//                 borderRadius: "999px",
//                 background: isVerified ? "#dcfce7" : "#fef2f2",
//                 color: isVerified ? "#166534" : "#b91c1c",
//                 fontSize: "13px",
//                 fontWeight: 600,
//               }}
//             >
//               Status: {isVerified ? "Verified ✓" : "Not Verified"}
//             </span>
//           </div>

//           {loading && (
//             <div
//               style={{
//                 padding: "24px",
//                 borderRadius: "16px",
//                 background: "#f8fafc",
//                 color: "#475569",
//                 textAlign: "center",
//               }}
//             >
//               Loading document details...
//             </div>
//           )}

//           {!loading && error && (
//             <div
//               style={{
//                 padding: "20px",
//                 borderRadius: "16px",
//                 background: "#fef2f2",
//                 color: "#b91c1c",
//                 border: "1px solid #fecaca",
//                 textAlign: "center",
//               }}
//             >
//               {error}
//             </div>
//           )}

//           {!loading && !error && !token && (
//             <div
//               style={{
//                 padding: "20px",
//                 borderRadius: "16px",
//                 background: "#fff7ed",
//                 color: "#9a3412",
//                 border: "1px solid #fed7aa",
//                 textAlign: "center",
//               }}
//             >
//               No token was provided in the QR URL.
//             </div>
//           )}

//           {!loading && !error && token && (
//             <>
//               <div
//                 style={{
//                   marginBottom: isMobile ? "100px" : "16px",
//                   color: "#475569",
//                   fontSize: "14px",
//                   textAlign: "center",
//                 }}
//               >
//                 Verified Document Card
//               </div>
//               {renderDocumentCard()}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PublicDocview;

import { useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import {
  clearProfileState,
  getVerifiedDocDataReducer,
} from "../../../Redux/Reducers/VerifiedDocReducer";
import Flag from "../../../Assets/img/Kyc/Flag1.jpg";
import Lion from "../../../Assets/img/Kyc/Lion.png";
import digi from "../../../Assets/img/Kyc/digi2.jpg";
import income_tax from "../../../Assets/img/Kyc/income_tax.png";
import adhaarMask from "../../../Assets/img/Kyc/adhaarMask.png";
import panMask from "../../../Assets/img/Kyc/PanCardMask.png";

const PublicDocview = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const QRData = useSelector((state) => state?.verified?.getVerifiedData?.data);
  const [isCardVisible, setIsCardVisible] = useState(false);
  const [isPanCardVisible, setIsPanCardVisible] = useState(false);
  const [isCaptureBlocked, setIsCaptureBlocked] = useState(false);
  const [isBlackScreen, setIsBlackScreen] = useState(false);
  const contentRef = useRef(null);
  const lastBlurTimeRef = useRef(0);

  // Show black screen function
  const showBlackScreen = (duration = 800) => {
    setIsBlackScreen(true);
    setIsCaptureBlocked(true);
    
    // Hide content
    if (contentRef.current) {
      contentRef.current.style.opacity = "0";
    }
    
    // Auto-hide black screen after duration
    setTimeout(() => {
      setIsBlackScreen(false);
      setIsCaptureBlocked(false);
      if (contentRef.current) {
        contentRef.current.style.opacity = "1";
      }
    }, duration);
  };

  // Watermark component that appears in screenshots
  const Watermark = () => (
    <div
      style={{
        position: "fixed",
        bottom: "30px",
        right: "30px",
        opacity: 0.4,
        zIndex: 1000,
        pointerEvents: "none",
        fontFamily: "monospace",
        fontSize: "12px",
        color: "#666",
        background: "rgba(255,255,255,0.7)",
        padding: "4px 8px",
        borderRadius: "4px",
        transform: "rotate(-5deg)",
      }}
    >
      🔒 Confidential • {new Date().toLocaleString()}
    </div>
  );

  useEffect(() => {
    // Block keyboard shortcuts
    const handleKeyDown = (event) => {
      const key = event.key.toLowerCase();
      
      // Block Print Screen
      if (key === "printscreen") {
        event.preventDefault();
        showBlackScreen();
        return false;
      }
      
      // Block Ctrl+P / Cmd+P
      if ((event.ctrlKey || event.metaKey) && key === "p") {
        event.preventDefault();
        showBlackScreen();
        return false;
      }
      
      // Block Ctrl+S / Cmd+S
      if ((event.ctrlKey || event.metaKey) && key === "s") {
        event.preventDefault();
        showBlackScreen();
        return false;
      }
      
      // Block Ctrl+Shift+S / Cmd+Shift+S
      if ((event.ctrlKey || event.metaKey) && event.shiftKey && key === "s") {
        event.preventDefault();
        showBlackScreen();
        return false;
      }
      
      // Block Ctrl+C / Cmd+C (copy)
      if ((event.ctrlKey || event.metaKey) && key === "c") {
        event.preventDefault();
        return false;
      }
      
      // Block Ctrl+X / Cmd+X (cut)
      if ((event.ctrlKey || event.metaKey) && key === "x") {
        event.preventDefault();
        return false;
      }
    };
    
    // Handle window blur (user switched to another app)
    const handleBlur = () => {
      const now = Date.now();
      // Prevent multiple rapid triggers
      if (now - lastBlurTimeRef.current > 100) {
        lastBlurTimeRef.current = now;
        showBlackScreen(500);
      }
    };
    
    // Handle window focus
    const handleFocus = () => {
      setTimeout(() => {
        setIsCaptureBlocked(false);
        setIsBlackScreen(false);
        if (contentRef.current) {
          contentRef.current.style.opacity = "1";
        }
      }, 100);
    };
    
    // Handle tab visibility change
    const handleVisibilityChange = () => {
      if (document.hidden) {
        showBlackScreen(500);
      } else {
        setTimeout(() => {
          setIsCaptureBlocked(false);
          setIsBlackScreen(false);
          if (contentRef.current) {
            contentRef.current.style.opacity = "1";
          }
        }, 100);
      }
    };
    
    // Block context menu (right-click)
    const blockContextMenu = (event) => {
      event.preventDefault();
      return false;
    };
    
    // Block copy/paste/cut
    const blockCopyPaste = (event) => {
      event.preventDefault();
      return false;
    };
    
    // Block drag and drop
    const blockDragDrop = (event) => {
      event.preventDefault();
      return false;
    };
    
    // Detect if user tries to take screenshot via browser extensions
    const detectScreenshotExtension = () => {
      // Add a hidden element that extensions might try to capture
      const detector = document.createElement("div");
      detector.id = "screenshot-detector";
      detector.style.cssText = `
        position: absolute;
        top: -9999px;
        left: -9999px;
        width: 1px;
        height: 1px;
        opacity: 0;
        pointer-events: none;
      `;
      document.body.appendChild(detector);
      
      // Monitor for changes that might indicate screenshot capture
      const observer = new MutationObserver(() => {
        showBlackScreen(600);
      });
      
      observer.observe(detector, { attributes: true, childList: true });
      
      return () => {
        observer.disconnect();
        if (detector && detector.remove) detector.remove();
      };
    };
    
    // Add event listeners
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    document.addEventListener("contextmenu", blockContextMenu);
    document.addEventListener("copy", blockCopyPaste);
    document.addEventListener("cut", blockCopyPaste);
    document.addEventListener("paste", blockCopyPaste);
    document.addEventListener("dragstart", blockDragDrop);
    document.addEventListener("drop", blockDragDrop);
    
    const cleanupExtensionDetection = detectScreenshotExtension();
    
    // Disable developer tools (basic protection)
    const handleDevToolsOpen = () => {
      const start = Date.now();
      debugger;
      const end = Date.now();
      if (end - start > 100) {
        showBlackScreen(1000);
      }
    };
    
    // Check for dev tools periodically
    const devToolsCheckInterval = setInterval(() => {
      const element = new Error();
      Object.defineProperty(element, 'stack', {
        get: () => {
          showBlackScreen(800);
          return '';
        }
      });
    }, 3000);
    
    // Cleanup
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("blur", handleBlur);
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.removeEventListener("contextmenu", blockContextMenu);
      document.removeEventListener("copy", blockCopyPaste);
      document.removeEventListener("cut", blockCopyPaste);
      document.removeEventListener("paste", blockCopyPaste);
      document.removeEventListener("dragstart", blockDragDrop);
      document.removeEventListener("drop", blockDragDrop);
      clearInterval(devToolsCheckInterval);
      if (cleanupExtensionDetection) cleanupExtensionDetection();
    };
  }, []);

  // Media query hook
  const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(false);
    
    useEffect(() => {
      const media = window.matchMedia(query);
      if (media.matches !== matches) {
        setMatches(media.matches);
      }
      const listener = () => setMatches(media.matches);
      media.addEventListener('change', listener);
      return () => media.removeEventListener('change', listener);
    }, [matches, query]);
    
    return matches;
  };
  
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isSmallScreen = useMediaQuery('(max-width: 480px)');
  
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  
  const docType = (
    params.docType || searchParams.get("docType") || "aadhar"
  ).toLowerCase();
  
  const token = decodeURIComponent(
    params.token || searchParams.get("token") || ""
  ).trim();
  
  const { getVerifiedData, loading, error } = useSelector(
    (state) => state?.verified || {}
  );
  
  useEffect(() => {
    dispatch(clearProfileState());
    
    if (token) {
      dispatch(getVerifiedDocDataReducer({ token, docType }));
    }
  }, [dispatch, token, docType]);
  
  const handleImageClick = () => {
    setIsCardVisible((prev) => !prev);
  };
  
  const handlePanImageClick = () => {
    setIsPanCardVisible((prev) => !prev);
  };
  
  const verifiedDetails = QRData?.verifiedDetails || {};
  const isVerified = QRData?.isVerified || false;
  
  // Black Screen Overlay Component
  const BlackScreenOverlay = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        backgroundColor: "#000000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#ffffff",
        padding: "24px",
        animation: "fadeIn 0.2s ease-in-out",
      }}
    >
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
        `}
      </style>
      <div>
        <div style={{ fontSize: "48px", marginBottom: "20px" }}>⚠️</div>
        <h2 style={{ margin: 0, fontSize: "24px", marginBottom: "12px" }}>
          Screen Capture Detected
        </h2>
        <p style={{ marginTop: "12px", fontSize: "16px", opacity: 0.9 }}>
          Screenshots and screen recording are disabled for security reasons.
        </p>
        <p style={{ marginTop: "8px", fontSize: "14px", opacity: 0.7 }}>
          This document contains sensitive information.
        </p>
      </div>
    </div>
  );
  
  // Render Aadhaar Card UI
  const renderAadhaarCard = () => {
    const aadharData = verifiedDetails;
    const photoBase64 = aadharData?.photo?.startsWith('/9j/')
      ? `data:image/jpeg;base64,${aadharData.photo}`
      : aadharData?.photo || null;
    
    return (
      <div
        style={{
          width: "400px",
          height: isMobile ? "590px" : "590px",
          margin: "auto",
          perspective: "1000px",
          cursor: "pointer",
        }}
        onClick={handleImageClick}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "relative",
            transformStyle: "preserve-3d",
            transition: "transform 0.6s",
            transform: isCardVisible ? "rotateY(180deg)" : "rotateY(0deg)",
          }}
        >
          {/* Front Side (Image) */}
          <div
            style={{
              width: "100%",
              height: "100%",
              backfaceVisibility: "hidden",
              position: "absolute",
              top: 0,
              left: 0,
            }}
          >
            <img
              src={adhaarMask}
              alt="Aadhaar Mask"
              style={{
                width: "100%",
                height: "100%",
                border: "2px solid gray",
                borderRadius: "15px",
              }}
            />
          </div>
          
          {/* Back Side (Card Details) */}
          <div
            style={{
              width: "100%",
              height: "100%",
              backfaceVisibility: "hidden",
              position: "absolute",
              top: 0,
              left: 0,
              transform: "rotateY(180deg)",
              backgroundColor: "white",
              border: "2px solid gray",
              borderRadius: "15px",
              padding: "10px",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                flexWrap: "wrap",
                rowGap: "10px",
              }}
            >
              <img
                style={{ width: "15%", minWidth: "50px", objectFit: "contain" }}
                src={Lion}
                alt="Lion Logo"
              />
              <img
                style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
                src={Flag}
                alt="Flag Logo"
              />
              <img
                style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
                src="https://www.pngkey.com/png/full/224-2240746_aadhaar-logo-aadhar-card-logo-png.png"
                alt="Aadhaar Logo"
              />
            </div>
            <div
              style={{
                display: "flex",
                padding: "10px",
                flexDirection: "row",
                gap: "10px",
                alignItems: "center",
                flexWrap: "wrap",
                width: "100%",
              }}
            >
              <img
                style={{
                  width: "30%",
                  minWidth: "120px",
                }}
                src={photoBase64 || "https://icon-library.com/images/man-png-icon/man-png-icon-14.jpg"}
                alt="Profile"
              />
              <div
                style={{
                  textAlign: "left",
                  flex: "1",
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "200px",
                  padding: "10px",
                }}
              >
                <h6>Name: {aadharData?.name || "N/A"}</h6>
                <h6>Aadhaar: {aadharData?.masked_id || "N/A"}</h6>
                <h6>DOB: {aadharData?.dob || "N/A"}</h6>
                <h6>Gender: {aadharData?.gender || "N/A"}</h6>
              </div>
            </div>
            <hr />
            <div style={{ textAlign: "left", padding: "10px" }}>
              <h6>
                Address: {aadharData?.house || ""} {aadharData?.street || ""}{" "}
                {aadharData?.locality || ""} {aadharData?.city || ""}{" "}
                {aadharData?.state || ""}
              </h6>
            </div>
            <hr />
            <div
              style={{
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "space-evenly",
                flexWrap: "wrap",
                rowGap: "15px",
              }}
            >
              <img
                style={{
                  width: "55%",
                  minWidth: "100px",
                  height: "auto",
                  objectFit: "contain",
                }}
                src={digi}
                alt="Digi Info"
              />
            </div>
            <hr style={{ color: "red", width: "80%", margin: "auto", padding: "5px" }} />
            <div style={{ display: "flex", justifyContent: "center" }}>
              <h6>
                <span style={{ color: "red" }}>आधार</span> - आम आदमी का अधिकार
              </h6>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  // Render PAN Card UI
  const renderPanCard = () => {
    const panData = verifiedDetails;
    
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "10px",
          flexWrap: "wrap",
          margin: "20px auto",
          maxWidth: isMobile ? "95%" : "90%",
          width: isMobile ? "100%" : "600px",
          perspective: "1000px",
          minHeight: isSmallScreen ? "50vh" : "65vh",
        }}
      >
        <div
          style={{
            flex: "1 1 auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transformStyle: "preserve-3d",
            transition: "transform 0.6s",
            transform: isPanCardVisible ? "rotateY(180deg)" : "rotateY(0deg)",
            cursor: "pointer",
            position: "relative",
            maxWidth: isMobile ? "100%" : "60%",
            padding: isMobile ? "5px" : "10px",
          }}
          onClick={handlePanImageClick}
        >
          {/* Front Side - Pan Mask */}
          <div
            style={{
              position: "absolute",
              backfaceVisibility: "hidden",
              width: "100%",
              marginTop: isSmallScreen ? "40vh" : "60vh",
              paddingTop: isSmallScreen ? "20vh" : ""
            }}
          >
            <img
              src={panMask}
              alt="Pan Mask"
              style={{
                border: "2px solid gray",
                borderRadius: "15px",
                width: isMobile ? "100%" : "90%",
                height: isSmallScreen ? "55vh" : "65vh",
              }}
            />
          </div>
          
          {/* Back Side - PAN Card */}
          <div
            style={{
              position: "absolute",
              backfaceVisibility: "hidden",
              transform: "rotateY(180deg)",
              width: "100%",
              marginTop: "65vh",
            }}
          >
            <div
              style={{
                border: "2px solid gray",
                borderRadius: "15px",
                padding: "20px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                backgroundColor: "white",
              }}
            >
              {/* Header */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  flexWrap: "wrap",
                  rowGap: "10px",
                }}
              >
                <img
                  style={{ width: "15%", minWidth: "50px", objectFit: "contain" }}
                  src={Lion}
                  alt="Lion Logo"
                />
                <img
                  style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
                  src={Flag}
                  alt="Flag Logo"
                />
                <img
                  style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
                  src={income_tax}
                  alt="Income Tax Logo"
                />
              </div>
              <hr style={{ color: "blue" }} />
              
              {/* Details Section */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginTop: "15px",
                  justifyContent: "center",
                }}
              >
                <div style={{ textAlign: "left", flex: "1 1 auto", alignItems: "flex-start" }}>
                  <p style={{ margin: "5px 0" }}>
                    <strong style={{ fontSize: "16px" }}>PAN Card</strong>
                  </p>
                  <p style={{ margin: "5px 0" }}>
                    Name: {panData?.name || "N/A"}
                  </p>
                  <p style={{ margin: "5px 0" }}>
                    PAN Number:
                    <span style={{ marginLeft: "5px" }}>
                      {panData?.pan_number || "N/A"}
                    </span>
                  </p>
                  <p style={{ margin: "5px 0" }}>
                    DOB: {panData?.dob || "N/A"}
                  </p>
                  <p style={{ margin: "5px 0" }}>
                    Gender: {panData?.gender || "N/A"}
                  </p>
                </div>
              </div>
              <hr />
              <p style={{ textAlign: "center", margin: "5px 0" }}>
                Digilocker | NEOIN
              </p>
              <hr />
              
              {/* Additional Details */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "5px",
                  marginTop: "10px",
                  marginBottom: "10px",
                  padding: "5px",
                }}
              >
                <img
                  style={{
                    width: "80%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                  src={digi}
                  alt="Digilocker Logo"
                />
              </div>
              <hr style={{ color: "blue", padding: "5px" }} />
              
              <div style={{ textAlign: "center" }}>
                <h6>स्थायी खाता संख्या कार्ड</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  // Render Document Card based on docType
  const renderDocumentCard = () => {
    if (docType === "aadhar") {
      return renderAadhaarCard();
    } else if (docType === "pan") {
      return renderPanCard();
    }
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <h3>Unsupported document type: {docType}</h3>
      </div>
    );
  };
  
  return (
    <>
      {/* Black Screen Overlay */}
      {isBlackScreen && <BlackScreenOverlay />}
      
      {/* Watermark */}
      <Watermark />
      
      {/* Main Content */}
      <div
        ref={contentRef}
        style={{
          minHeight: "100vh",
          padding: "32px 16px",
          background: "linear-gradient(180deg, #f8fafc 0%, #eef2ff 45%, #ffffff 100%)",
          position: "relative",
          userSelect: "none",
          WebkitUserSelect: "none",
          transition: "opacity 0.2s ease-in-out",
        }}
      >
        <div
          style={{
            maxWidth: "960px",
            height: isMobile ? "950px" : "",
            margin: "0 auto",
            background: "rgba(255,255,255,0.9)",
            border: "1px solid #e5e7eb",
            borderRadius: "24px",
            boxShadow: "0 18px 60px rgba(15, 23, 42, 0.08)",
            overflow: "hidden",
          }}
        >
          <div style={{ padding: "28px" }}>
            <div
              style={{
                display: "flex",
                gap: "12px",
                flexWrap: "wrap",
                marginBottom: "20px",
              }}
            >
              <span
                style={{
                  padding: "8px 12px",
                  borderRadius: "999px",
                  background: "#eff6ff",
                  color: "#1d4ed8",
                  fontSize: "13px",
                  fontWeight: 600,
                }}
              >
                Document: {docType}
              </span>
              <span
                style={{
                  padding: "8px 12px",
                  borderRadius: "999px",
                  background: isVerified ? "#dcfce7" : "#fef2f2",
                  color: isVerified ? "#166534" : "#b91c1c",
                  fontSize: "13px",
                  fontWeight: 600,
                }}
              >
                Status: {isVerified ? "Verified ✓" : "Not Verified"}
              </span>
            </div>
            
            {loading && (
              <div
                style={{
                  padding: "24px",
                  borderRadius: "16px",
                  background: "#f8fafc",
                  color: "#475569",
                  textAlign: "center",
                }}
              >
                Loading document details...
              </div>
            )}
            
            {!loading && error && (
              <div
                style={{
                  padding: "20px",
                  borderRadius: "16px",
                  background: "#fef2f2",
                  color: "#b91c1c",
                  border: "1px solid #fecaca",
                  textAlign: "center",
                }}
              >
                {error}
              </div>
            )}
            
            {!loading && !error && !token && (
              <div
                style={{
                  padding: "20px",
                  borderRadius: "16px",
                  background: "#fff7ed",
                  color: "#9a3412",
                  border: "1px solid #fed7aa",
                  textAlign: "center",
                }}
              >
                No token was provided in the QR URL.
              </div>
            )}
            
            {!loading && !error && token && (
              <>
                <div
                  style={{
                    marginBottom: isMobile ? "100px" : "16px",
                    color: "#475569",
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                >
                  Verified Document Card
                </div>
                {renderDocumentCard()}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PublicDocview;